import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private readonly snackBar = inject(MatSnackBar);

  dismissable(message: string, action: string): void {
    this.snackBar.open(message, action);
  }

  default(message: string): void {
    this.snackBar.open(message, '', {
      duration: 2000,
      panelClass: 'snackbar-default'
    });
  }

  success(message: string): void {
    this.snackBar.open(message, '', {
      duration: 2000,
      panelClass: 'snackbar-success'
    });
  }

  error(message: string): void {
    this.snackBar.open(message, '', {
      duration: 4000,
      panelClass: 'snackbar-danger'
    });
  }
}
